<template>
  <div class="flex items-center mb-1 w-full px-2">
      <button class="toggle text-center w-1/10 pr-6" @click="removeProduct(product)">
        <close-icon class="hover:text-b2c-red-300" />
      </button>
      <img :src="selectedProduct.cover" class="w-1/5 py-1" :alt="getAltText(selectedProduct.description)">
      <section class="flex flex-grow py-1 pl-2 w-7/10 justify-between items-center" :aria-label="$t('product.details')">
        <div class="flex flex-col text-left w-4/5">
          <span class="text-sm">{{ selectedProduct['description_'+$i18n.locale] ? selectedProduct['description_'+$i18n.locale] : selectedProduct.description}}</span>
          <div class="w-20 pt-1">
            <inc-dec
              :appOptions="{
                min: selectedProduct.min_quantity,
                max: selectedProduct.max_purchasable_quantity
              }"
              v-model="qty"
            />
          </div>
        </div>
        <h2 class="font-bold w-1/5 text-right pr-2">
          {{ formatter.format(totalPriceToShow / 100) }}
        </h2>
      </section>
  </div>
</template>

<script>
import IncDec from '@/components/IncDec.vue';
import { mapState, mapGetters } from 'vuex';
import { getProduct } from '@/services/ProductService';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  components: { IncDec, CloseIcon },

  props: ['product'],

  data() {
    return {
      qty: this.product.quantity,
      selectedProduct: {},
    };
  },

  computed: {
    ...mapState('cart', {
      tax_rate: (state) => state.tax_rate + 100,
    }),
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
      isTaxable: 'auth/isTaxable',
    }),

    totalDiscountedPrice() {
      return this.selectedProduct.discounted_price * this.qty;
    },
    discountedPriceWithVat() {
      return (this.totalDiscountedPrice * this.vat_rate) / 100;
    },
    roundedDiscountedPriceWithVat() {
      return Math.round(this.discountedPriceWithVat);
    },
    totalPrice() {
      return this.totalDiscountedPrice;
    },
    totalPriceWithVat() {
      return (this.totalPrice * this.vat_rate) / 100;
    },
    totalPriceToShow() {
      if (!this.isTaxable) {
        return this.totalPrice;
      }
      return this.totalPriceWithVat;
    },
    vat_rate() {
      return 100 + this.selectedProduct.vat_rate;
    },
  },

  mounted() {
    this.selectedProduct = this.product;
  },

  watch: {
    qty() {
      this.$store.dispatch('cart/updateProductQuantity', {
        productToUpdate: this.product,
        quantity: this.qty,
      });
    },

    changedLocale() {
      this.getSelectedProduct();
    },
  },

  methods: {
    removeProduct(productToRemove) {
      this.$store.dispatch('cart/removeProduct', productToRemove);
    },

    getSelectedProduct() {
      getProduct(this.selectedProduct.sku).then((response) => {
        this.selectedProduct = {};
        this.selectedProduct = response.data;
        this.checkProductStock(this.selectedProduct);
      }).catch(() => {
        this.createNotification('error', `${this.$t('notifications.errorReload')}`);
      });
    },

    checkProductStock(product) {
      if (product.out_of_stock === 1) {
        this.removeProduct(this.product);
        this.createNotification('info', `${this.$t('notifications.outOfStockFirst')} ${product.description} ${this.$t('notifications.outOfStockSecond')}`);
      }
    },

    getAltText(productDescription) {
      return `${this.$t('product.alt')} ${productDescription}`;
    },
  },

};
</script>

<style lang="scss" scoped>
.toggle {
  @apply font-bold text-xs cursor-pointer;
}
</style>
